<template>
<div class="chapter">
<div class="inner_page">
<figure>
<p class="image2"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"><img alt="Rank-and-file members..." height="388" src="images/f0viii-01.jpg" width="466"/></span></p>
</figure>
<p class="caption">Rank-and-file members of SITRABI, Morales, Izabal, Guatemala, at a COSIBAH workshop on domestic violence, November 2002</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Image1.vue?06846677